<main class="main mt-3">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>Calls:</div>
        <div class="remove-block-button">
          <a class="btn btn-sm" (click)="removeBlock()"
            ><i class="bi bi-trash-fill remove-block-icon"></i
          ></a>
        </div>
      </div>
      <div class="row">
        <div class="ui-grid-row">
          <div class="ui-grid-col-12">
            <p-select
              #countriesDropdown
              [options]="countries"
              [(ngModel)]="selectedCountry"
              optionLabel="name"
              optionValue="name"
              [disabled]="disabled"
              [filter]="true"
              filterBy="name"
              [showClear]="true"
              placeholder="Select country"
              [style]="{ width: '25%', zIndex: '3' }"
              [ngModelOptions]="{ standalone: true }"
              name="countriesDropdown"
              resetFilterOnHide="true"
              scrollHeight="25rem"
              (onChange)="onChange($event.value ?? '', 'Country')"
            >
              <ng-template let-country pTemplate="item">
                <div class="block-item-content">
                  {{ country.name }}
                </div>
              </ng-template>
            </p-select>
          </div>
        </div>
        <div class="col-12">
          <app-block-text
            [maxLength]="4000"
            [type]="'content'"
            [blockData]="block.variables?.['TelephoneNumber'] ?? ''"
            (handleOnChange)="onChange($event, 'TelephoneNumber')"
            [placeholder]="telephoneNumberPlaceholder"
            variable="TelephoneNumber"
            [isPlainText]="true"
            [blockId]="block.blockId"
          ></app-block-text>
        </div>
      </div>
    </div>
    <!-- <div
      class="right-side-container"
      [id]="block.blockId"
      (click)="onContainerClick($event)"
    >
      <app-pin [block]="block"></app-pin>
      <div class="right-side">
        <div class="row">
          <div *ngIf="block.variables?.['FirstImage']" class="row col-6">
            <a
              [href]="helper.getFullUrl(block.variables?.['FirstImageHref'])"
              target="_blank"
            >
              <img
                [src]="block.variables?.['FirstImage']"
                class="img-fluid"
                [alt]="block.variables?.['FirstImageAlt']"
              />
            </a>
          </div>

          <div *ngIf="block.variables?.['SecondImage']" class="row col-6">
            <a
              [href]="helper.getFullUrl(block.variables?.['SecondImageHref'])"
              target="_blank"
            >
              <img
                [src]="block.variables?.['SecondImage']"
                class="img-fluid"
                [alt]="block.variables?.['SecondImageAlt']"
              />
            </a>
          </div>
        </div>
      </div>
    </div> -->
    <!-- <div class="comments-side" *ngIf="!isPreview">
      <app-notification
        [notifications]="block.notifications"
        [blockId]="block.blockId"
      ></app-notification>
    </div> -->
  </div>
</main>
